import { RouteHandler } from 'wee-routes';
import AOS from 'aos/dist/aos';

export default new RouteHandler({
    init() {
        AOS.init();
    },
});